import React, { FC, useEffect, useState } from 'react';
import Paper from 'components/Paper/paper';
import { campanha, paginatedResponse } from 'models/campanhas';
import campanhaService from 'services/campanha-service/campanha-service';
import CampaignDeleteModal from 'components/CampanhasMkt-components/CampanhasMktDeleteModal/campaign-delete-modal';
import {
  UseCampanhaContext,
  UseCampanhaTableContext,
} from 'context/campanha-context';
import { columnTable } from 'utils/campanha-utils';
import Pagination from './Pagination/pagination';
import ItemsColumn from './ItemsColumn/items-column';
import * as S from './style';

const CampanhasTable: FC = () => {
  const { open, selected, setOpen } = UseCampanhaTableContext();

  const {
    page,
    setPage,
    setIsLoading,
    refreshList,
    setRefreshList,
    currentFilters,
  } = UseCampanhaContext();

  const [currentItems, setCurrentItems] = useState<campanha[]>([]);
  const [paginated, setPaginated] = useState<paginatedResponse>();

  const loadCampanhas = async (targetPage: number) => {
    try {
      setIsLoading(true);
      const response = await campanhaService.getCampanhas(
        targetPage,
        currentFilters,
      );
      setPaginated(response);
      setCurrentItems(response.resultados);
    } catch (err) {
      const error = err as { status?: number };
      if (error?.status === 404) {
        setCurrentItems([]);
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!refreshList) return;
    const isNewPage = paginated?.resultados.length === 1 && page !== 1;
    if (isNewPage) setPage(page - 1);
    loadCampanhas(isNewPage ? page - 1 : page);
    setRefreshList(false);
  }, [refreshList]);

  useEffect(() => {
    loadCampanhas(page);
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {selected && (
        <CampaignDeleteModal
          setOpen={setOpen}
          selected={selected}
          open={open}
        />
      )}

      <S.ContainerTable>
        <S.Table borderless>
          <thead>
            <S.Line>
              {columnTable.map((item) => (
                <td key={item}>{item === 'Contatos' ? 'Público' : item}</td>
              ))}
            </S.Line>
          </thead>
          {currentItems.length ? (
            <Paper as="tbody" maxWidth={1510} height={637}>
              {currentItems.map((value, index) => (
                <ItemsColumn
                  key={value['id-campanha']}
                  index={index}
                  value={value}
                />
              ))}
              {currentItems.length < 10 && (
                <S.Line emptyLine>
                  <td colSpan={6} aria-hidden="true" />
                </S.Line>
              )}
            </Paper>
          ) : (
            <Paper as="tbody" maxWidth={1510} height={637}>
              <S.Line>
                <S.NoResultsFoundStyled colSpan={10}>
                  Nenhum Resultado Encontrado
                </S.NoResultsFoundStyled>
              </S.Line>
            </Paper>
          )}
        </S.Table>
      </S.ContainerTable>
      {paginated && (
        <Pagination
          paginatedResponse={paginated}
          handlePageChange={loadCampanhas}
        />
      )}
    </>
  );
};

export default CampanhasTable;
